import {
  START_GET_ACTIVITY_LOG,
  SUCCESS_GET_ACTIVITY_LOG,
  ERROR_GET_ACTIVITY_LOG,
  START_GET_FIELD_STAFF_LIST,
  SUCCESS_GET_FIELD_STAFF_LIST,
  ERROR_GET_FIELD_STAFF_LIST,
} from "Actions/ActivityAction";
import { activityLogAPI, staffSearchAPI } from "Api/ActivityLogApi";
import { call, put, takeEvery } from "redux-saga/effects";

function* getActivityWorker({ payload, loadmore }) {
  try {
    const res = yield call(activityLogAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_ACTIVITY_LOG,
        payload: res,
        loadmore: loadmore,
      });
    } else {
      yield put({
        type: ERROR_GET_ACTIVITY_LOG,
        payload: res,
      });
    }
  } catch (error) {}
}
function* getStaffListApi({ payload }) {
  try {
    const res = yield call(staffSearchAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_FIELD_STAFF_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_FIELD_STAFF_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}
export function* ActivitySaga() {
  yield takeEvery(START_GET_ACTIVITY_LOG, getActivityWorker);
  yield takeEvery(START_GET_FIELD_STAFF_LIST, getStaffListApi);
}
